import { IEmptyResult } from '../types/IResponse';
import { IIdItem } from '../types/resourceParts';
import { Request } from './Request';

export interface ISetDatasourceRefreshModeParams extends IIdItem {
  refreshMode: string;
}

export class SetDatasourceRefreshModeRequest extends Request<ISetDatasourceRefreshModeParams, IEmptyResult> {
  constructor(params: ISetDatasourceRefreshModeParams) {
    super('setDatasourceRefreshMode', params);
  }
}
